import Am from '@assets/CustomIcons/am.png'
import Pm from '@assets/CustomIcons/pm.png'
import { FormNumberInput } from '@components/_SiteWide/Form/FormNumberInput'
import { DataItemRow, MomentDatePicker, MomentTimePicker, Texto } from '@gravitate-js/excalibrr'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { Col, Form, Select } from 'antd'
import moment from 'moment'
import { useEffect, useState } from 'react'

const { Option } = Select

export function DriverSchedule({ driver, editing, metadata, setStartTimeOverridden, form, isPatternStartRequired }) {
  const color = driver?.shift_preference === 'am' ? 'var(--theme-color-2)' : 'var(--theme-color-3)'
  const [autoSchedule, setAutoSchedule] = useState(false)

  useEffect(() => {
    if (driver) {
      setAutoSchedule(driver.auto_schedule)
    }
  }, [driver])

  return (
    <Col span={16} className='right-side'>
      <Texto category='h5'>{`Schedule`}</Texto>

      <div className='driver-form-line schedule pt-3'>
        <DataItemRow label='Shift' labelSpan={8} valueSpan={16}>
          <Form.Item name='shift_preference' rules={[{ required: true, message: 'Shift Required.' }]}>
            {editing ? (
              <Select placeholder='Shift' allowClear>
                <Option value='am'>Morning</Option>
                <Option value='pm'>Evening</Option>
              </Select>
            ) : (
              <div className='pb-3' style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                <span className='pr-3'>
                  <img alt='shift icon' src={driver?.shift_preference === 'am' ? Am : Pm} />
                </span>
                <span
                  style={{
                    color,
                  }}
                >
                  {driver?.shift_preference === 'am' ? 'Morning' : 'Evening'}
                </span>
              </div>
            )}
          </Form.Item>
        </DataItemRow>
      </div>
      <div className='driver-form-line'>
        <DataItemRow label='Template' labelSpan={8} valueSpan={16}>
          <Form.Item
            name='preferred_template'
            rules={[{ required: autoSchedule, message: 'Shift Template Required.' }]}
            data-cy='template-input'
          >
            {editing ? (
              <Select placeholder='Template' allowClear showSearch>
                {metadata
                  .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
                  .map((option, index) => (
                    <Option key={index} value={option.name}>
                      {option.name}
                    </Option>
                  ))}
              </Select>
            ) : (
              <div className='pb-3' style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                {driver?.preferred_template && driver.preferred_template.slice(-2) === 'AM'
                  ? driver.preferred_template.slice(0, -2).concat('Morning')
                  : driver?.preferred_template
                    ? driver.preferred_template.slice(0, -2).concat('Evening')
                    : null}
              </div>
            )}
          </Form.Item>
        </DataItemRow>
      </div>
      {/** TODO: Replace hardcoded template name with pattern bool from BE once we get it ;) */}
      {isPatternStartRequired && (
        <div className='driver-form-line'>
          <DataItemRow label='Pattern Start Date' labelSpan={8} valueSpan={16}>
            <Form.Item
              name='pattern_schedule_start_date'
              rules={[{ required: true, message: 'Pattern start date is required' }]}
              data-cy='pattern-start-date-input'
            >
              {editing ? (
                <MomentDatePicker />
              ) : (
                <Texto align='right' appearance='secondary' weight='bold'>
                  {formatters.DATE(moment(driver?.pattern_schedule_start_date))}
                </Texto>
              )}
            </Form.Item>
          </DataItemRow>
        </div>
      )}

      <div className='driver-form-line'>
        <DataItemRow label='Shift Start' labelSpan={8} valueSpan={16}>
          <Form.Item name={'shift_start_time'}>
            {editing ? (
              <MomentTimePicker
                placeholder='Choose Start Time'
                onFocus={() => setStartTimeOverridden(true)}
                minuteStep={15}
                use12Hours
                format={formatters.TIME}
                showSecond={false}
              />
            ) : (
              <div>
                <ShiftStartDisplay
                  overrideTime={
                    driver?.shift_preference === 'am' ? driver?.am_shift_start_time : driver?.pm_shift_start_time
                  }
                  inheritedOverride={driver?.shift_preference === 'am' ? driver?.am_shift : driver?.pm_shift}
                  timezone={driver?.am_shift_start_time_local}
                />
              </div>
            )}
          </Form.Item>
        </DataItemRow>
      </div>
      <div className='driver-form-line'>
        <DataItemRow label='Shift Length Hours' labelSpan={8} valueSpan={16}>
          <Form.Item name={'shift_length_hours'}>
            {editing ? (
              <FormNumberInput
                editable
                placeholder='Enter Shift Length (hrs)'
                min={0}
                max={24}
                step={0.5}
                addonAfter='hr'
                data-cy='shift-length-input'
              />
            ) : (
              <div>
                <ShiftLengthDisplay
                  shiftLengthHours={driver.shift_length.shift_length_hours}
                  shiftLengthType={driver.shift_length.type}
                />
              </div>
            )}
          </Form.Item>
        </DataItemRow>
      </div>
    </Col>
  )
}

function ShiftStartDisplay({ overrideTime, inheritedOverride, timezone }) {
  if (overrideTime) {
    return (
      <Texto align='right' appearance='secondary' weight='bold'>
        {formatters.TIME(moment(overrideTime), timezone)}
      </Texto>
    )
  }
  return (
    <>
      <Texto align='right' appearance='medium'>
        {formatters.TIME(moment(inheritedOverride?.start_time), timezone)}
      </Texto>
      <Texto align='right' category='label' appearance='medium'>
        (From {inheritedOverride?.type})
      </Texto>
    </>
  )
}

function ShiftLengthDisplay({ shiftLengthHours, shiftLengthType }) {
  if (shiftLengthType === 'driver') {
    return (
      <Texto align='right' appearance='secondary' weight='bold'>
        {shiftLengthHours}
      </Texto>
    )
  }
  return (
    <>
      <Texto align='right' appearance='medium'>
        {shiftLengthHours}
      </Texto>
      <Texto align='right' category='label' appearance='medium'>
        (From {shiftLengthType})
      </Texto>
    </>
  )
}
